<template>
<div id="app">
  <v-app>
    <v-content>
      <v-parallax
        :height="$vuetify.breakpoint.smAndDown ? 700 : 800"
        :src="key_visual"
      >

        <v-container class="text-center">
          <h1 class="display-1 font-weight-bold mb-3">
              <v-img
                :src="ocean_logo"
              ></v-img>
          </h1>
        </v-container>

      </v-parallax>

      <NakedLP/>
    </v-content>

    <v-footer
      color="dark"
      app
    >
      <v-container class="text-center">
        <span class="white--text">&copy; {{ new Date().getFullYear() }} NAKED, INC.</span>
      </v-container>
    </v-footer>
  </v-app>
</div>
</template>



<script>
import NakedLP from './components/NakedLP';

export default {
  name: 'App',

  components: {
    NakedLP,
  },

  data: () => ({
    // キービジュアル
    key_visual : './Images/kv.jpg',

    // 会社ロゴ
    ocean_logo : './Images/key_logo.png',

  }),

  theme: {
    dark: true,
  },
};
</script>
